import React, { Component } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
class PrintAsaysh extends Component {
 render() {
  const {
   lang,
   change_Lang,
   create_asaysh,
   logo,
   name_arb,
   name_en,
   name_krd,
  } = this.props;
  return (
   <>
    <br />
    <div class={`${lang === "en" ? "container-fluid" : "container-fluid fk"}`}>
     <div class="row">
      <div class="col-12">
       <div class="row">
        <div class="col-6 text-right ">
         <br />
         <div className="form-inline">
          <div class="col-sm-6">
           <p
            style={{
             fontSize: "20px",
             color: "#000",
             fontWeight: "bold",
            }}
            class="mb-1 d-flex justify-content-start"
           >
            <span
             style={{
              fontSize: "22px",
              color: "#000",
              fontWeight: "bold",
             }}
            >
             {/* {change_Lang("Company Name")}: */}
             ناوی عقارات:
            </span>
           </p>
          </div>
          <label
           style={{
            color: "#000",
            fontWeight: "bolder",
            fontSize: "22px",
           }}
          >
           عقارات ژیوای زەنگین
          </label>
         </div>
         <div className="form-inline">
          <div class="col-sm-6">
           <p
            style={{
             fontSize: "20px",
             color: "#000",
             fontWeight: "bold",
            }}
            class="mb-1 d-flex justify-content-start"
           >
            <span
             style={{
              fontSize: "22px",
              color: "#000",
              fontWeight: "bold",
             }}
            >
             {change_Lang("Company mobile number")}:
            </span>
           </p>
          </div>
          <label
           style={{
            color: "#000",
            fontWeight: "bolder",
            fontSize: "22px",
           }}
          >
           2023 939 0770
          </label>
         </div>
         <div className="form-inline">
          <div class="col-sm-6">
           <p
            style={{
             fontSize: "20px",
             color: "#000",
             fontWeight: "bold",
            }}
            class="mb-1 d-flex justify-content-start"
           >
            <span
             style={{
              fontSize: "22px",
              color: "#000",
              fontWeight: "bold",
             }}
            >
             {change_Lang("date")}:
            </span>
           </p>
          </div>
          <Time
           value={create_asaysh.createdAt}
           format="YYYY-MM-DD"
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
          />
         </div>
         <br />
        </div>
        <div class="col-6 d-flex justify-content-center">
         <img
          src={logo}
          style={{
           position: "fixed",
           top: -120,
           height: "450px",
           width: "450px",
          }}
          className="img-fluid img-responsive"
         />
        </div>
       </div>
       <div className="row">
        <label
         className="col-12 text-center my-4"
         style={{
          color: "#000",
          fontWeight: "bolder",
          fontSize: "24px",
         }}
        >
         {" "}
         (سولەیمانی - 30 مەتری شەقامی ئازادی بەرامبەر شاری خەونەکان)
        </label>
       </div>
       <br />
       <div class="row">
        <div class="col-12">
         <p
          style={{
           fontSize: "20px",
           color: `#fff`,
           background: `#18a99e`,
           fontWeight: "bold",
           borderRadius: "20px",
          }}
          class="mb-4 d-flex justify-content-center text-uppercase p-1"
         >
          {change_Lang("Sceurity Anket")}
         </p>
         {/* title asaysh */}
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>
            {change_Lang("to")} &nbsp;&nbsp;-
            {create_asaysh.scuertyName}-
           </h3>
          </div>
          <div className="col-12 d-flex justify-content-center">
           <h4 style={{ fontWeight: "bold" }}>
            {change_Lang("Subject : Residential consent")}.
           </h4>
          </div>
         </div>
         <hr
          style={{
           height: "5px",
           backgroundColor: `#18a99e`,
          }}
         />
         <br />
         {/* title */}
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>
            {change_Lang("Current tenant")}
           </h3>
          </div>
         </div>
         <br />
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("The name of the tenant")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.tenantname}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("where they came")}:
          </label>
          <div
           class="col-sm-2 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.tenantadress}
          </div>
         </div>
         {/* second */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {" "}
           {change_Lang("invoice_mob")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.tenantphone}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Nation")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.tenant_nationality}
          </div>
         </div>
         {/* code */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {" "}
           کۆدی ئاسایش (کرێچی) :
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.scuretyCodeTenant}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          ></label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          ></div>
         </div>
         <hr
          style={{
           height: "5px",
           backgroundColor: `#18a99e`,
          }}
         />
         {/* Thisrd */}
         {/* title three */}
         <br />
         <div className="row">
          <div className="col-12 d-flex justify-content-center">
           <h3 style={{ fontWeight: "bold" }}>
            {change_Lang("Owner of the property")}
           </h3>
          </div>
         </div>
         <br />
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Owner Name")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.ownername}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Owner Phone")}:
          </label>
          <div
           class="col-sm-2 d-flex justify-content-start"
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
          >
           {create_asaysh.ownerPhone}
          </div>
         </div>
         {/* second */}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Type of property")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {change_Lang(create_asaysh.property_type)}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Property Address")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.ownerSeating}
          </div>
          <br />
          <br />
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {change_Lang("Number of property")}:
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.NoOfPropert}
          </div>
         </div>{" "}
         <div class="form-group row form-inline">
          <label
           style={{
            fontSize: "19px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          >
           {" "}
           کۆدی ئاسایش (خاوەن موڵک) :
          </label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          >
           {create_asaysh.scuretyCode}
          </div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-3 col-form-label"
          ></label>
          <div
           class="col-sm-3 d-flex justify-content-start"
           style={{ fontSize: "20px", fontWeight: "bold" }}
          ></div>
         </div>
         <br /> <br />
         <hr
          style={{
           height: "5px",
           backgroundColor: `#18a99e`,
          }}
         />
         <br />
         <br /> <br /> <br /> <br />
         {/* New One  */}
         <div class="form-group row form-inline">
          <div className="col-1"></div>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-5 col-form-label d-flex justify-content-start"
          >
           {change_Lang("Base Signature")}
          </label>
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           class="col-sm-5 col-form-label  d-flex justify-content-end"
          >
           {/* {change_Lang("The company's signature")} */}
           واژووی عقارات
          </label>
          <div className="col-1"></div>
         </div>
         {/* Thisrd */}
         <br />
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}
const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  create_asaysh: state.Invoice_Reducer.create_asaysh,
  primary_logo: state.HelperReducer.primary_logo,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  logo: state.HelperReducer.logo,
  name_krd: state.HelperReducer.name_krd,
  name_arb: state.HelperReducer.name_arb,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrintAsaysh);
